/** Mirror backend caps for NFT quantity UI (Treydora storefront). */

export const LIBRARY_NFT_TIER_CHECKOUT_MAX = {
  merch_rights: 5,
  armory: 25,
  reader_access: 50,
};

export function maxNftCheckoutForTier(tierKey) {
  const tk = String(tierKey || "").trim();
  return LIBRARY_NFT_TIER_CHECKOUT_MAX[tk] ?? 1;
}

/**
 * Per-checkout max capped by live inventory remaining (when API provided a count).
 * @param {string} tierKey
 * @param {number|null|undefined} inventoryRemaining count of LibraryNftTokenInventory rows in "available"
 */
export function effectiveMaxNftCheckoutForTier(tierKey, inventoryRemaining) {
  const cap = maxNftCheckoutForTier(tierKey);
  if (inventoryRemaining == null || !Number.isFinite(Number(inventoryRemaining))) return cap;
  const rem = Math.max(0, Math.floor(Number(inventoryRemaining)));
  return Math.min(cap, rem);
}

export function clampNftCheckoutQuantity(tierKey, raw, inventoryRemaining) {
  const max = effectiveMaxNftCheckoutForTier(tierKey, inventoryRemaining);
  const n = parseInt(String(raw), 10);
  const base = Number.isInteger(n) && n >= 1 ? n : 1;
  if (max < 1) return 1;
  return Math.min(max, base);
}
